module.exports = __webpack_public_path__ + "files/c13d9e6d9d5e10ed78910f16eb619c61.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-800.svg
 ** module id = 966
 ** module chunks = 0
 **/